import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.NumberPicker,
  title: 'Number Picker',
  category: ComponentCategory.FormControls,
};
